import ViewReplacementDelivery from "../../../../components/@documents/replacement_delivery/ViewReplacementDelivery";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ReplacementDeliveryViewPage() {

    return (
        <ViewReplacementDelivery 
            routeType={routeTypes.workstation}
        />
    )
}